var React = require('react');

function UpwardsArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeWidth":"2","transform":"rotate(-90 26 25)"},[React.createElement("circle",{"cx":"25","cy":"25","r":"25","key":0}),React.createElement("path",{"d":"M20.935 11.565L34.37 25 20.935 38.435","key":1})]));
}

UpwardsArrow.defaultProps = {"viewBox":"0 0 52 52"};

module.exports = UpwardsArrow;

UpwardsArrow.default = UpwardsArrow;
